// http://shop.herbertz.de/shop/rest/data/search/typeahead?value=111&count=5&art_nr=true
import app from "app.controller"
import productStore from "stores/productStore"


export default class Typeahead {
  constructor( { shop, config } ) {
    this.config = config
    this.shop = shop
  }

  fetch( { value, artnr = "0", sort = "sort", count = 25 } ) {
    if ( value && value.value ) {
      value = value.value
    }
    if ( !value || value.length < 3 ) {
      return Promise.resolve( [] )
    }
    return this.shop.fetchCached( `/shop/rest/data/search/typeahead?value=${encodeURIComponent( value )}&count=${count}&sort=${sort}&artnr=${artnr}${app.getQueryLanguageParameter()}` )
      .then( res => res.map( hit => {
        if ( hit.id ) return hit.id
        return hit
      } ) )
  }


  load( value, { artnr = "1", sort = "sort", count = 25 } ) {
    if ( value && value.value ) {
      value = value.value
    }
    return this.fetch( {
      value, artnr, sort, count
    } )
  }


  loadWithProductsFromSearch( value, { artnr = 1, count = 42, sort = "article_nr", dir = "desc" } = {} ) {
    return productStore.search( value, {
      count   : count,
      page    : 1,
      artnr   : artnr,
      sort    : sort,
      dir     : dir
    }, { useArtNr: false } )
  }


  loadWithProducts( value, { ...rest } ) {
    return this.load( value, { ...rest } )
      .then( ids => {
        return this.shop.products.list( ids )
      } )
      .then( res => {
        return res
      } )
  }


}



// WEBPACK FOOTER //
// ./src/sdk/Typeahead.js